// Lib
import React, { ReactElement } from 'react';
import { connect } from 'react-redux';

// Actions
import { initialiseWorkspace } from './workspaceInitialisationActions';
import { appSetInitialised } from '../../app/initialisation/initialisationActions';
import rIC from '../../../common/utils/lib/rIC';

// Components
import WorkspaceInitialisationMonitoring from './WorkspaceInitialisationMonitoring';

interface WorkspaceInitialisationManagerProps {
    isGuest: boolean;
    dispatchInitialiseWorkspace: Function;
    dispatchSetWorkspaceLoadIdleTimestamp: Function;
}

const mapDispatchToProps = (dispatch: Function) => ({
    dispatchInitialiseWorkspace: () => dispatch(initialiseWorkspace()),
    dispatchSetWorkspaceLoadIdleTimestamp: () => dispatch(appSetInitialised({ workspaceLoadIdle: true })),
});

/**
 * Handles the triggering of app initialisation on mount / user logout & authentication
 * as well as setting the idle load time after app initialisation completes.
 */
const WorkspaceInitialisationManager = (props: WorkspaceInitialisationManagerProps): ReactElement => {
    const { isGuest, dispatchInitialiseWorkspace, dispatchSetWorkspaceLoadIdleTimestamp } = props;

    // Initialise the workspace on mount or when the user's authentication status changes
    React.useEffect(() => {
        dispatchInitialiseWorkspace();
    }, [isGuest]);

    React.useEffect(() => {
        // When the page has idled for the first time, mark it as initialised
        rIC(() => {
            dispatchSetWorkspaceLoadIdleTimestamp();
        });
    }, []);

    return <WorkspaceInitialisationMonitoring />;
};

export default connect(null, mapDispatchToProps)(WorkspaceInitialisationManager);
